import { Reveal, SectionLabel, Icon } from "./ui";
import RichHTML from "../RichHTML";

export default function Zielgruppen({ items = [], index, appr }) {
  return (
    <section id="zielgruppen" style={appr?.style} className={`py-20 lg:py-28 ${appr?.dark ? "mf-section-dark" : ""}`}>
      <div className="mf-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal><SectionLabel index={index}>Für wen wir arbeiten</SectionLabel></Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-head font-light tracking-tight text-[1.875em] lg:text-[2.6em] leading-tight mt-6 text-[var(--mf-ink)] max-w-2xl">
                Jede Einrichtung hat <span className="font-medium">eigene Anforderungen</span>.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <p className="text-[1em] text-[var(--mf-ink-soft)] max-w-sm leading-relaxed">
              Vom einzelnen Prüftermin bis zur laufenden Betreuung mehrerer Standorte.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((z, i) => (
            <Reveal key={z.id || i} delay={(i % 3) * 0.08}>
              <div
                data-testid={`zielgruppe-${i}`}
                className="group relative bg-white border border-[var(--mf-line)] overflow-hidden h-full flex flex-col min-h-[220px]"
              >
                {z.image ? (
                  <div className="relative h-40 overflow-hidden">
                    <img
                      src={z.image}
                      alt={`Beispiel ${z.title}`}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                  </div>
                ) : (
                  <div className="h-40 bg-[var(--mf-mist)] flex items-center justify-center border-b border-[var(--mf-line)] relative">
                    <Icon name={z.icon} size={44} strokeWidth={1.2} className="text-[var(--mf-grey)] group-hover:text-[var(--mf-red)] transition-colors duration-500" />
                  </div>
                )}
                <div className="p-6 flex-1">
                  <h3 className="font-head font-bold text-[1.125em] text-[var(--mf-ink)]">{z.title}</h3>
                  <div className="mt-2 text-[0.875em] leading-relaxed text-[var(--mf-ink-soft)]"><RichHTML html={z.description} /></div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
